export function EmployeeDashboard() {
  return (
    <>
      <p>
        This is the Employee Dashboard..... Will include employee options only
      </p>
    </>
  );
}
